import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import * as TraceLoggingOverrideActions from './trace-logging-override.actions';
import { TraceLoggingOverride } from './trace-logging-override.model';

export const traceLoggingOverrideFeatureKey = 'TraceLoggingOverride';

export interface State extends EntityState<TraceLoggingOverride> {}

export const adapter: EntityAdapter<TraceLoggingOverride> =
    createEntityAdapter<TraceLoggingOverride>({
        selectId: (model: TraceLoggingOverride) =>
            `${model.TraceLoggingOverrideId}`
    });

export const initialState: State = adapter.getInitialState({});

export const traceLoggingOverrideReducer = createReducer(
    initialState,
    on(TraceLoggingOverrideActions.loadTraceLoggingOverrides, (state, action) =>
        adapter.setAll(action.overrides, state)
    ),
    on(TraceLoggingOverrideActions.clearTraceLoggingOverrides, state =>
        adapter.removeAll(state)
    )
);

export function reducer(state: State | undefined, action: Action) {
    return traceLoggingOverrideReducer(state, action);
}

export const selectTraceLoggingOverrideState = createFeatureSelector<State>(
    traceLoggingOverrideFeatureKey
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(selectTraceLoggingOverrideState);
